export const getHeader = (state: { header: any; }) => {
    return state.header;
};

export const getSideMenu = (state: { sideMenu: any; }) => {
    return state.sideMenu;
};
